// Numeric `size` is treated as design pixels and rendered in cqw so the
// spinner scales with the canvas. Pass a string (e.g. "32px") to opt out.
export default function RuneSpinner({ size = 48, useViewportUnits = false, className = '' }) {
  let dim;
  if (useViewportUnits) dim = `${size / 10}vmin`;
  else if (typeof size === 'number') dim = `${size / 16}cqw`;
  else dim = size;
  return (
    <img
      src="/rune-divider.webp"
      alt=""
      className={`animate-spin-slow ${className}`}
      draggable={false}
      style={{
        width: dim,
        height: dim,
        filter: 'sepia(1) saturate(3) brightness(0.8) hue-rotate(15deg)',
      }}
    />
  );
}
